import React, {useMemo} from "react";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {PermissionEditor} from "../PermissionEditor";
import {BaseAutocomplete} from "../../../../designSystem/components/BaseAutocomplete";
import {BaseInput} from "../../../../designSystem/components/BaseInput";
import {Typography} from "../../../../designSystem/components/Typography";

export const UserCreateForm = ({
  newUser,
  organizations,
  selectedRole,
  userRole,
  onChangeNewUser,
  onChangeRole,
  handleAddUser,
}) => {

  const isValidSubmit = useMemo(() => {
    return (newUser.name && newUser.email && newUser.organization?.name && (selectedRole || !Object.values(newUser.permissions).every(value => value === false)))
  }, [newUser, selectedRole])

  return (
    <div className="w-full md:w-[600px] max-w-full flex flex-col gap-4 p-8">
      <Typography variant="title">
        新增帳號
      </Typography>
      <BaseInput
        onChange={(e) => onChangeNewUser({name: e.target.value})}
        value={newUser.name}
        placeholder="姓名/名稱"
      />
      <BaseInput
        onChange={(e) => onChangeNewUser({email: e.target.value})}
        value={newUser.email}
        placeholder="Email"
      />
      <BaseAutocomplete
        label="業務組別"
        options={organizations}
        onChangeValue={(value) => {
          onChangeNewUser({organization: value ? {id: value.id, name: value.name} : null})
        }}
      />
      <PermissionEditor
        permissions={newUser.permissions}
        role={selectedRole}
        userRole={userRole}
        onChangeRole={onChangeRole}
        onChangePermissions={permissions => onChangeNewUser({permissions})}
      />
      <div className="mt-8">
        <ActionButton
          label="新增"
          iconName="fa-plus"
          onClick={handleAddUser}
          fullWidth
          disabled={!isValidSubmit}
        />
      </div>
    </div>
  )
}
